import { render } from "./TooltipGoalDetail.vue?vue&type=template&id=1b7d5dd2&scoped=true"
import script from "./TooltipGoalDetail.vue?vue&type=script&lang=js"
export * from "./TooltipGoalDetail.vue?vue&type=script&lang=js"

import "./TooltipGoalDetail.vue?vue&type=style&index=0&id=1b7d5dd2&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b7d5dd2"]])

export default __exports__